<!--
 * @Description: 背景粒子特效
 * @Author: hasayake
 * @Date: 2020-04-13 10:40:11
 * @LastEditTime: 2020-04-15 09:47:36
 * @LastEditors: Please set LastEditors
-->

<template functional>
  <vue-particles
      color="#d4ecff"
      :particleOpacity="0.8"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#e9edf2"
      :linesWidth="2"
      :lineLinked="true"
      :lineOpacity="0.8"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
      class="cash"
    ></vue-particles>
</template>

<script>
export default {
  name: 'particales'
}
</script>

<style scoped>
.cash {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>